import React from 'react';

const FormInput = ({ label, id, name, value, onChange, type = 'text', placeholder = '' }) => (
  <div>
    <label htmlFor={id} className="gdl-form-label">{label}</label>
    <input
      type={type}
      id={id}
      name={name}
      value={value || ''}
      onChange={onChange}
      placeholder={placeholder}
      className="gdl-form-input"
    />
  </div>
);

export default FormInput;
